import { DevelopmentEnvironmentState } from "./developmentEnvironmentState";

export enum Actions {
  LOAD_STATE = "LOAD_STATE",
  SET_HIDE_MENU = "SET_HIDE_MENU",
  SET_SHOW_MENU = "SET_SHOW_MENU",
  SET_SHOW_LOCATION_STATE = "SET_SHOW_LOCATION_STATE",
  SHOW_VERSION_NOTIFIER = "SHOW_VERSION_NOTIFIER",
}

export type Action =
  | { type: Actions.SET_SHOW_LOCATION_STATE; payload: boolean }
  | { type: Actions.SET_SHOW_MENU; payload: boolean }
  | { type: Actions.SET_HIDE_MENU; payload: boolean }
  | { type: Actions.SHOW_VERSION_NOTIFIER }
  | { type: Actions.LOAD_STATE; payload: typeof DevelopmentEnvironmentState };
